import dynamic from "next/dynamic";

import type { Props as AdSlotProps } from "scmp-app/components/advertisement/ad-slots/ad-slot";

export const DynamicAdSlot = dynamic<AdSlotProps>(() =>
  import("scmp-app/components/advertisement/ad-slots/ad-slot").then(module => module.AdSlot),
);
